import React from 'react';
import type { AiAdvice, AiManager } from '../types/meeting';

interface AiHistoryPageProps {
  isOpen: boolean;
  onClose: () => void;
  aiAdviceHistory: AiAdvice[];
  aiManagers: AiManager[];
  onShowAiManagerSelection: () => void;
}

// OKLCH色生成関数
const getManagerColor = (id: number): string => {
  const hue = (id * 137.508) % 360;
  return `oklch(0.45 0.15 ${hue})`;
};

// 相対時間を計算
const formatRelativeTime = (timestamp: Date): string => {
  const now = new Date();
  const diffMs = now.getTime() - timestamp.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 1) return 'たった今';
  if (diffHours < 1) return `${diffMinutes}分前`;
  if (diffDays < 1) return `${diffHours}時間前`;
  return `${diffDays}日前`;
};

// テキストの改行を<br>タグに変換
const formatAdviceText = (text: string): string => {
  if (!text) return '';
  return text.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>');
};

const AiHistoryPage: React.FC<AiHistoryPageProps> = ({
  isOpen,
  onClose,
  aiAdviceHistory,
  aiManagers,
  onShowAiManagerSelection,
}) => {
  const getManager = (managerId: number): AiManager | undefined => {
    return aiManagers.find((m) => m.id === managerId);
  };

  return (
    <div className={`page history-page ${isOpen ? 'active' : ''}`} id="history-page">
      <div className="page-header history-header">
        <div className="back-button material-symbols-outlined" onClick={onClose}>
          arrow_back
        </div>
        <div className="page-title history-title">AIマネージャー</div>
        <div
          className="settings-icon material-symbols-outlined"
          onClick={onShowAiManagerSelection}
        >
          settings
        </div>
      </div>
      <div className="page-content history-content">
        <div className="list history-list" id="history-list">
          {aiAdviceHistory.map((advice, index) => {
            const manager = getManager(advice.managerId);
            const managerName = advice.managerName || manager?.name || 'AIマネージャー';
            const managerColor = getManagerColor(advice.managerId);

            return (
              <div key={`${advice.managerId}-${index}`} className="ai-advice-bubble">
                <div
                  className="ai-advice-avatar"
                  style={{ backgroundColor: managerColor }}
                >
                  <span className="material-symbols-outlined">smart_toy</span>
                </div>
                <div className="ai-advice-content">
                  <div
                    className="ai-advice-text"
                    dangerouslySetInnerHTML={{ __html: formatAdviceText(advice.text) }}
                  />
                  <div className="ai-advice-meta">
                    <span className="ai-advice-name">{managerName}</span>
                    <span className="ai-advice-time">
                      {formatRelativeTime(advice.timestamp)}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AiHistoryPage;

